export const setLocale = (locale: string) => {
  localStorage.setItem('locale', locale)
}

export const getLocale = () => {
  return localStorage.getItem('locale')
}
